import {Tag} from "@livingdesign/react";

const MuiTagItem = (props) => {
  const { value, color, variant, id="Mui-Tag-Item" } = props;

  return (
    <Tag color={color} variant={variant} data-testid="Mui-Tag-Item" id={id}>
      {value}
    </Tag>
  );
}

export default MuiTagItem;
